import {Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-proposal-preview-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title>Solution Proposal</h2>
    <mat-dialog-content style="height: 70vh; padding: 0;">
      <iframe [src]="safeUrl" sandbox="allow-scripts" style="width: 100%; height: 100%; border: 0;"></iframe>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="copyLink()"><mat-icon>link</mat-icon> COPY LINK</button>
      <button mat-button (click)="download()"><mat-icon>download</mat-icon> DOWNLOAD</button>
      <button mat-flat-button color="primary" mat-dialog-close>CLOSE</button>
    </mat-dialog-actions>
  `,
})
export class ProposalPreviewDialogComponent {
  readonly url: string;
  readonly safeUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {slug: string},
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ProposalPreviewDialogComponent>
  ) {
    this.url = `${environment.apiUrl}/public/proposal/${data.slug}`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  copyLink(): void {
    void navigator.clipboard.writeText(this.url);
  }

  download(): void {
    fetch(this.url)
      .then((r) => r.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'proposal.html';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
  }
}
